<template>
  <div class="courier-chart-item" v-if="statData && columnName">
    <h2 class="courier-chart-item__heading">
      {{ title }}
    </h2>
    <div class="courier-chart-item__diagram">
      <pie
        :chart-options="chartOptions"
        :chart-data="chartData"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
    <div class="px-3 pb-3 courier-chart-item__legend-list">
      <v-row align="center">
        <v-col
          cols="12"
          md="6"
          xl="4"
          v-for="item in usersData"
          :key="item.userId"
        >
          <div class="courier-chart-item__legend-item">
            <div
              class="courier-chart-item__legend-color"
              :style="{background: item.color}"
            >
              {{ item.percent }}%
            </div>
            <div class="courier-chart-item__legend-name">
              {{ item.userName }}
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { Pie } from 'vue-chartjs/legacy'

  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  } from 'chart.js'

  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

  export default {
    name: 'CourierChartItem',
    components: { Pie },
    data () {
      return {
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              display: false,
            },
          },
        },
      }
    },
    props: {
      title: String,
      statData: {
        type: Array,
        default: () => ([]),
      },
      columnName: String,
      userColors: {
        type: Object,
        default: () => ({}),
      },

      chartId: {
        type: String,
        default: 'pie-chart',
      },
      datasetIdKey: {
        type: String,
        default: 'label',
      },
      width: {
        type: Number,
        default: 400,
      },
      height: {
        type: Number,
        default: 400,
      },
      cssClasses: {
        default: '',
        type: String,
      },
      styles: {
        type: Object,
        default: () => {},
      },
      plugins: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      allCount () {
        return this.statData.reduce(
          (previousValue, row) => previousValue + row[this.columnName],
          0,
        )
      },
      usersData () {
        return this.statData.map(row => {
          return {
            userId: row.user.id,
            userName: row.user.name,
            count: row[this.columnName],
            percent: Math.round(row[this.columnName] / this.allCount * 100),
            color: this.getUserColor(row.user.id),
          }
        })
      },
      chartData () {
        const chart = {
          labels: [],
          datasets: [
            {
              backgroundColor: [],
              data: [],
            },
          ],
        }

        this.usersData.forEach(row => {
          chart.labels.push(`  ${row.userName} - ${row.percent}%`)
          chart.datasets[0].backgroundColor.push(row.color)
          chart.datasets[0].data.push(row.count)
        })

        return chart
      },
    },
    methods: {
      getUserColor (userId) {
        return this.userColors[userId] ?? '#CCC'
      },
    },
  }
</script>

<style lang="less" scoped>
  .courier-chart-item {
    border-radius: 8px;
    box-shadow: 0px 3px 4px 0px rgba(192, 192, 192, 0.4);
    border: 1px solid rgba(219, 216, 216, 0.7);
    padding: 25px 18px 10px 18px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 28px;
      color: rgba(50, 48, 48, 1);
      margin-bottom: 30px;
    }

    &__diagram {
      margin-bottom: 20px;
      width: 70%;
    }

    &__legend-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

    }

    &__legend-item {
      display: flex;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      align-items: center;
    }

    &__legend-color {
      width: 32px;
      height: 32px;
      flex-basis: 32px;
      color: white;
      background: #7b7b7b;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 200px;
      font-size: 10px;
      align-self: center;
      flex-shrink: 0;
    }
  }
</style>
